export class EquipmentClassType {
    id: number;
    name: string;
    description: string;
    constructor(obj?: EquipmentClassType) {
        if (obj) {
            this.id = obj.id;
            this.name = obj.name;
            this.description = obj.description;
        }
    }
}
